module.exports = __webpack_public_path__ + "static/media/customer-day.874fb2f9.png";